import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { handleClientMethod } from "@saflib/sdk";
import { getClient } from "../../client.ts";
import type { PowerUpServiceRequestBody } from "@vendata/power-up-spec";

export const useUpdateOrganization = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (
      data: PowerUpServiceRequestBody["updateOrganization"],
    ) => {
      return handleClientMethod(
        getClient().PUT("/organization", { body: data }),
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["organization"] });
    },
  });
};
